import Swiper, { EffectFade, Autoplay } from 'swiper'
Swiper.use([EffectFade, Autoplay])
import 'swiper/css'
import 'swiper/css/effect-fade'

const alertBar = document.querySelectorAll('.alert-bar')

if (alertBar.length > 0) {
  document.querySelectorAll('.alert-bar__inner-container').forEach((el) => {
    new Swiper(el, {
      autoplay: {
        delay: 3000,
      },
      speed: 800,
      loop: true,
      slidesPerView: 1,
      centeredSlides: true,
      watchSlidesProgress: true,
      effect: 'fade',
    })
  })
}
